import axios from "axios";

export const fetchCountryStateOptions = (countryId: number) => {
    return axios.get(`/api/country/states/${countryId}`);
};
